/**
 * Tipos dos monitores do credenciado, no Portal do Credenciado.
 *
 * A fonte é `GET /bff/v1/j05-s01-cadastrar-monitor/state` (ver
 * `comum/recursos.ts`). A tela segue o protótipo (`PortalMonitores.tsx`,
 * `PortalMonitorDetail.tsx`), e os campos que ele mostra e a API ainda não
 * devolve estão aqui como `null`: a tela diz "—" neles em vez de inventar.
 * Quando a API passar a devolvê-los, só `paraOMonitor` (em `dados.ts`) muda.
 */

import type { ItemDoChecklist } from '@/modulos/portal-credenciado/comum/contrato';
import type { EstadoDoCadastro } from '@/modulos/portal-credenciado/comum/recursos';

export interface Monitor {
  id: string;
  nome: string;
  /** Sem pontuação. A máscara é da tela. */
  cpf: string;
  /** Estado do cadastro do monitor (análise do DTP). */
  situacao: EstadoDoCadastro;
  documentos: ItemDoChecklist[];

  // Os campos abaixo o protótipo mostra e a API ainda não devolve.
  email: string | null;
  /** Sem pontuação. A máscara é da tela. */
  telefone: string | null;
  rg: string | null;
  /** `AAAA-MM-DD`, sem hora. */
  data_nascimento: string | null;
  endereco: string | null;
  bairro: string | null;
  cep: string | null;
  /** Ex.: "CLT", "Autônomo", "Cooperado". */
  vinculo_empregaticio: string | null;
  /** Curso de primeiros socorros concluído. `null` quando não se sabe. */
  curso_primeiro_socorros: boolean | null;
  /** Curso de capacitação para monitor de transporte escolar. `null` quando não se sabe. */
  curso_transporte_escolar: boolean | null;
  observacoes: string | null;
}

export interface FiltroDeMonitores {
  busca?: string;
}

/**
 * `dd/mm/aaaa` a partir de `AAAA-MM-DD`, sem passar por `new Date` — que lê a
 * data como meia-noite UTC e, no fuso de São Paulo, mostra o dia anterior.
 */
export function formatarDia(dataIso: string | null): string {
  const partes = dataIso?.slice(0, 10).split('-');
  if (!partes || partes.length !== 3) {
    return '—';
  }
  const [ano, mes, dia] = partes;
  return `${dia}/${mes}/${ano}`;
}
